import React, { FC } from 'react';
import TransparentButton from '../../shared/transparent-button/transparent-button';
import './qnada-button-group.scss';
import { BackDrop, DropDownButton } from '../../index';

interface IProps {
  isReviewMode: boolean;
  questionsExist: boolean;
  isMoreMenuOpen: boolean;
  downloadCSV: () => Promise<void>;
  toggleReviewMode: () => void;
  toggleOpenMenu: (open:boolean) => void;
}

const QnadaButtonGroup: FC<IProps> = (
  { isReviewMode, toggleReviewMode, toggleOpenMenu, isMoreMenuOpen, downloadCSV, questionsExist }
):JSX.Element => {
  const showConfirmationPopup = () => {
    toggleReviewMode();
    toggleOpenMenu(false);
  };

  return (
    <>
      <BackDrop isVisible={isMoreMenuOpen} backdropTop/>
      <section className="qanda__button-group">
        <DropDownButton
          isOpen={isMoreMenuOpen}
          setIsOpen={toggleOpenMenu}
          classException="mobile-dropdown-tab"
          rootClass="qanda__button-group__mobile-dropdown"
        >
          More...
        </DropDownButton>
        <div className="qanda__button-group_wrapper">
          <div className="switch-mode-button-wrapper mobile-dropdown-tab mobile-dropdown-list-item">
            <span className="toggle-label--mobile">Review mode</span>
            <label className="toggle mobile-dropdown-tab">
              <input
                onChange={showConfirmationPopup}
                className="toggle-checkbox"
                type="checkbox"
                checked={isReviewMode}
              />
              <div className="toggle-switch"/>
            </label>
            <span className="toggle-label">Review mode is {isReviewMode ? 'on' : 'off'}</span>
            <div className="tooltip">
              <button className="tooltip-symbol">
                ?
              </button>
              <span className="tooltiptext">Turn on to review and prioritize submitted questions</span>
            </div>
          </div>
          <div className="mobile-dropdown-list-item">
            <TransparentButton
              customClasses="download-icon"
              onClick={downloadCSV}
              disabled={!questionsExist}
            >
              Download Q&A
            </TransparentButton>
          </div>
        </div>
      </section>
    </>
  );
};

export default QnadaButtonGroup;
